import { render, staticRenderFns } from "./ContentTestimonial.vue?vue&type=template&id=0c34c44d&scoped=true&"
import script from "./ContentTestimonial.vue?vue&type=script&lang=js&"
export * from "./ContentTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./ContentTestimonial.vue?vue&type=style&index=0&id=0c34c44d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34c44d",
  null
  
)

export default component.exports